import React from "react";
import TabLayout from "../../components/TabLayout";
import ReviewQuestion from "./ReviewQuestion";
import ReviewQuestionAnswer from "./ReviewQuestionAnswer";
import ReviewForm from "./ReviewForm";
import {Grid} from "@mui/material";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";

export default function ReviewTabs(props) {
    return (
        <Grid container spacing={0.5}>
            <Grid item xs={12}><Typography variant="h5">Questions & Answers </Typography></Grid>
            <Grid item xs={12}><Divider/></Grid>
            <Grid item xs={12}>
                <TabLayout
                    tabs={[
                        {title: "Review Questions", component: <ReviewQuestion/>},
                        {title: "Review Answers", component: <ReviewQuestionAnswer/>},
                        {title: "Review Form", component: <ReviewForm/>},
                    ]}
                />
            </Grid>
        </Grid>
    );
}